export default __webpack_public_path__ + "static/black-49176b51ec5626157da067b197a94cba.png";